import React, { useEffect, useState } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { i18nIntl, getRoundLabel, convertObjectToArray } from '../../../lib/ep.js';

import ActionLink from '../../builder/ActionLink';

import FloatingLayerPublic from '../../front/FloatingLayerPublic';

const sortCandidates = (candidates) => {
	//return candidates;

	return candidates.sort((x, y) => {
		let c_x = x.round.toUpperCase();
		let c_y = y.round.toUpperCase();
		if(c_x > c_y) return -1;
		if(c_x < c_y) return 1;
		return 0;
	});
};

const BracketCandidates = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	let bracket = (props.bracket != undefined) ? props.bracket : false;
	const teams = (props.teams != undefined) ? props.teams : false;
	if(!bracket || !teams) return null;

	let is_builder = (props.is_builder != undefined) ? props.is_builder : false;

	let _grouped_teams = {
		active:{
			candidates:[],
			label:i18n("Active"),
		},
		out:{
			candidates:[],
			label:i18n("Eliminated"),
		},
		winner:{
			candidates:[],
			label:i18n("Winner"),
		},
	};

	let has_descriptions = false;
	teams.map((team, t) => {
		if(team.description != undefined && team.description != "") has_descriptions = true;

		let status = (parseInt(bracket.current_round) > parseInt(team.round)) ? 'out' : 'active';
		if(status == 'active' && parseInt(bracket.current_round) > parseInt(bracket.num_rounds)) status = 'winner';

		_grouped_teams[status].candidates.push(team);
	});

	const grouped_teams = convertObjectToArray(_grouped_teams);

	return (
		<FloatingLayerPublic
			pm={props.promotion}
			title={`<h1>${props.intl.formatMessage({id:"Candidates in {bracket}"}, {bracket:bracket.title})}</h1>`}
			backButton={() => props.backButton()}
			is_builder={is_builder}
		>
			<div class="candidates_layer_info">
				<FormattedMessage id="{num} candidates" values={{num:Math.pow(2, parseInt(bracket.num_rounds))}} />

				{(props.link_to_single_bracket != undefined) && (
					<div>
						<ActionLink icon='knk-brackets' _href={props.link_to_single_bracket} _target="_blank">View bracket</ActionLink>
					</div>
				)}
			</div>

			<div class="all_candidates_groups">
				{grouped_teams.map((group, g) => {
					if(group.candidates.length == 0) return null;

					return (
						<div key={`group_${g}`} class={'candidates_group is_' + group.key}>
							<p><strong>{group.label}</strong> [{group.candidates.length}]</p>

							<ul class={'gui_candidates_list' + ((has_descriptions) ? ' with_descriptions' : '')}>
								{sortCandidates(group.candidates).map((candidate, c) => {
									const has_image = (candidate.full_image != undefined) ? true : false;
									const has_bg_color = (!has_image && candidate.color != undefined && candidate.color != "") ? true : false;
									const has_description = (candidate.description != undefined && candidate.description != "") ? true : false;

									let candidate_info_class = ['candidate_info', 'gui_main_text_color_on_bg'];
									if(!has_description) candidate_info_class.push('without_description');

									return (
										<li key={`cand_${c}`} class={'candidate is_' + group.key}>
											<div>
												{(has_image) && (
													<div class="candidate_img gui_pos_rel" style={{backgroundImage:'url(' + candidate.full_image + ')'}}>
														<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
													</div>
												)}

												{(has_bg_color) && (
													<div class="candidate_img gui_pos_rel" style={{background:candidate.color, flexBasis:((has_description) ? '36px' : '24px')}}>
														<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
													</div>
												)}

												<div class={candidate_info_class.join(" ")}>
													<div>
														<span>
															<strong>{candidate.name}</strong>

															{(group.key == 'out') && (
																<span> ({getRoundLabel(bracket, parseInt(candidate.round), false, props.intl)})</span>
															)}
														</span>

														{(has_description) && (
															<div class="description" dangerouslySetInnerHTML={{ __html:candidate.description.replace(/\n/g, '<br />') }} />
														)}
													</div>
												</div>
											</div>
										</li>
									)
								})}
							</ul>
						</div>
					)
				})}
			</div>
		</FloatingLayerPublic>
	)
};

export default injectIntl(BracketCandidates);